<template>
  <div class="relative flex">
    <button
      v-if="useNewIcon"
      id="language-menu-button"
      ref="languageMenuRef"
      type="button"
      class="rounded-full hover:bg-gray-50 focus:outline-none"
      @click="toggleLanguageMenu"
    >
      <svg
        :class="customStyle"
        viewBox="0 0 40 41"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M31.9112 29.8941L27.0897 18.2152C27.0006 17.9995 26.8496 17.8151 26.6556 17.6853C26.4617 17.5556 26.2336 17.4863 26.0003 17.4863C25.7669 17.4863 25.5388 17.5556 25.3449 17.6853C25.151 17.8151 24.9999 17.9995 24.9109 18.2152L20.0893 29.8941C20.0293 30.0373 19.9983 30.191 19.9979 30.3462C19.9975 30.5015 20.0278 30.6553 20.087 30.7988C20.1462 30.9423 20.2332 31.0728 20.343 31.1825C20.4528 31.2923 20.5832 31.3794 20.7267 31.4386C20.8702 31.4979 21.024 31.5282 21.1793 31.5278C21.3346 31.5274 21.4882 31.4964 21.6315 31.4364C21.7747 31.3765 21.9047 31.2888 22.0139 31.1785C22.1232 31.0682 22.2096 30.9374 22.2681 30.7936L23.2501 28.4155H28.7504L29.7324 30.7936C29.8214 31.0093 29.9725 31.1938 30.1665 31.3236C30.3605 31.4534 30.5887 31.5227 30.8221 31.5227C31.0158 31.5226 31.2064 31.4747 31.3772 31.3834C31.548 31.2921 31.6936 31.1601 31.8013 30.9991C31.9089 30.838 31.9752 30.653 31.9943 30.4603C32.0133 30.2675 31.9847 30.0731 31.9107 29.8941H31.9112ZM24.2235 26.0583L26.0005 21.7537L27.7775 26.0583H24.2235ZM20.6347 25.0361C20.8178 24.7832 20.893 24.4679 20.8439 24.1595C20.7948 23.8512 20.6253 23.5749 20.3727 23.3914C20.362 23.3834 19.5691 22.7951 18.4178 21.5308C20.542 18.655 21.7452 15.3833 22.236 13.8436H23.9648C24.2773 13.8436 24.5771 13.7194 24.7982 13.4984C25.0192 13.2774 25.1434 12.9776 25.1434 12.665C25.1434 12.3524 25.0192 12.0526 24.7982 11.8316C24.5771 11.6106 24.2773 11.4864 23.9648 11.4864H17.7503V10.4149C17.7503 10.1023 17.6261 9.80257 17.4051 9.58153C17.1841 9.3605 16.8843 9.23633 16.5717 9.23633C16.2591 9.23633 15.9593 9.3605 15.7383 9.58153C15.5172 9.80257 15.3931 10.1023 15.3931 10.4149V11.4864H9.17861C8.86602 11.4864 8.56624 11.6106 8.34521 11.8316C8.12417 12.0526 8 12.3524 8 12.665C8 12.9776 8.12417 13.2774 8.34521 13.4984C8.56624 13.7194 8.86602 13.8436 9.17861 13.8436H19.7459C19.2359 15.2874 18.2967 17.5669 16.8642 19.6488C15.1815 17.4159 14.5563 15.971 14.5514 15.9592C14.4283 15.6745 14.1978 15.4499 13.91 15.334C13.6223 15.2181 13.3005 15.2203 13.0144 15.3402C12.7282 15.46 12.5009 15.6879 12.3817 15.9742C12.2625 16.2606 12.2609 16.5825 12.3775 16.8699C12.4085 16.9439 13.1569 18.7038 15.2093 21.3663C15.2586 21.4301 15.3074 21.4922 15.3561 21.5544C13.2539 23.9303 11.1913 25.4041 10.3283 25.8799C10.0538 26.0295 9.85011 26.2821 9.7619 26.582C9.67369 26.8819 9.70823 27.2046 9.85791 27.479C10.0076 27.7534 10.2602 27.9572 10.5601 28.0454C10.86 28.1336 11.1826 28.0991 11.4571 27.9494C11.5728 27.8862 14.0607 26.5088 16.9017 23.3641C18.1082 24.6541 18.9375 25.2627 18.9873 25.2981C19.1126 25.3891 19.2547 25.4545 19.4054 25.4906C19.5561 25.5267 19.7124 25.5328 19.8654 25.5084C20.0184 25.484 20.1651 25.4297 20.2971 25.3485C20.4291 25.2674 20.5438 25.1611 20.6347 25.0355V25.0361Z"
          fill="#101828"
        />
      </svg>
    </button>

    <button
      v-else
      id="language-menu-button"
      ref="languageMenuRef"
      type="button"
      class="inline-flex items-center justify-center w-full px-4 py-2 text-sm font-medium text-gray-700 bg-white hover:bg-gray-50 focus:outline-none no-localize-translate"
      @click="toggleLanguageMenu"
    >
      {{ currentLanguage.name }}
      <svg
        class="flex-shrink-0 w-3 h-3 ml-1 text-gray-400 fill-current"
        viewBox="0 0 12 12"
      >
        <path d="M5.9 11.4L.5 6l1.4-1.4 4 4 4-4L11.3 6z" />
      </svg>
    </button>
    <div
      v-if="isOpen"
      class="absolute right-0 mt-2 bg-white rounded-md shadow-lg top-full ring-1 ring-black ring-opacity-5 focus:outline-none"
    >
      <button
        v-for="lang in languages"
        :key="lang.code"
        class="block w-full px-4 py-2 text-sm text-gray-700 rounded-md hover:bg-gray-100 hover:text-gray-900 no-localize-translate break-keep"
        @click.prevent="selectLanguage(lang)"
      >
        {{ lang.name }}
      </button>
    </div>
  </div>
</template>

<script setup>
const props = defineProps({
  userCurrentLanguage: {
    type: String,
    default: 'en',
  },
  customStyle: {
    type: String,
    default: 'size-10 cursor-pointer transition-all',
  },
  useNewIcon: {
    type: Boolean,
    default: false,
  },
})

const emit = defineEmits(['language-changed'])
const isOpen = ref(false)
const languageMenuRef = ref(null)
const languages = [
  { code: 'en', name: 'EN' },
  { code: 'zh-Hans', name: '中文' },
]

const toggleLanguageMenu = () => {
  isOpen.value = !isOpen.value
}

const currentLanguage = computed(() => {
  const found = languages.find(lang => lang.code === props.userCurrentLanguage)
  return found || languages[0]
})

const selectLanguage = (lang) => {
  isOpen.value = false
  useEventTracker().capture({
    eventName: 'user-language-switched',
    properties: {
      language: lang.code,
    },
  })
  emit('language-changed', lang.code)
}

// Close menu when clicking outside
onClickOutside(languageMenuRef, () => {
  isOpen.value = false
})
</script>
